import request from '@/utils/request'

/**
 * 获取题目选项
 * @param {*} query 
 * @returns 
 */
export function getOptions (query) {
  return request({
    url: `/api/Battle/getOptions`,
    method: 'GET',
    params: query
  });
}

export function getOptionConf(query) {
  return request({
    url: '/api/Battle/getOptionConf',
    method: 'GET',
    params: query
  })
}

/**
 * 提交答题结果
 * @param {*} data 
 * @returns 
 */
export function finishQuiz(data) {
  return request({
    url: '/api/Battle/finishQuiz',
    method: 'post',
    data: data
  })
}

/**
 * 更新用户昵称
 * @param {*} data 
 * @returns 
 */
export function updateQuizNickname(data) {
  return request({
    url: '/api/Battle/updateNickname',
    method: 'post',
    data: data
  })
}

/**
 * 获取排行榜
 * @param {*} query 
 * @returns 
 */
export function getRank(query) {
  return request({
    url: '/api/Battle/getRank',
    method: 'GET',
    params: query
  })
}

export function getRecords() {
  return request({
    url: '/api/Battle/getRecords',
    method: 'get',
  })
}

/**
 * 获取用户信息
 * @param {*} uid 
 * @returns 
 */
export function getUserInfo(uid) {
  return request({
    url: '/api/User/getInfo',
    method: 'GET',
    params: { uid }
  })
}

/**
 * 发送短信验证码
 * @param {*} data 
 * @returns 
 */
export function sendSmsCode(data) {
  return request({
    url: '/api/sms/dispatch',
    method: 'POST',
    data: data
  })
}

/**
 * 验证短信验证码
 * @param {*} data 
 * @returns 
 */
export function mobileLogin(data) {
  return request({
    url: '/api/user/mobilelogin',
    method: 'POST',
    data: data
  })
}

export function getWxConfig(query) {
  return request({
    url: '/api/wx/config',
    method: 'GET',
    params: query
  })
}